/**
 * Valida la respuesta del GAS Kommo → espejo Sheets.
 * completed=false = sólo se ha guardado un lote en staging, NO actualiza
 * la fecha ni se declara éxito de la sincronización.
 */
export function validateKommoSyncResult(result) {
  if (!result || result.ok !== true || result.success === false) {
    throw new Error(
      String((result && (result.error || result.message)) || 'Kommo no confirmó la sincronización de leads.')
    );
  }

  const count = Number(result.filasLeads);
  const countLabel = result.filasLeads != null && Number.isFinite(count) && count >= 0
    ? count.toLocaleString('es-CL') + ' leads descargados'
    : 'Leads descargados';

  if (result.completed === false) {
    return {
      warning: false,
      inProgress: true,
      message: countLabel + ' en preparación (' + Number(result.paginas || 0) +
        ' páginas). El espejo anterior sigue publicado; podés reanudar si se interrumpe.'
    };
  }

  if (result.completed === true && result.coverage === 'complete') {
    return {
      warning: false,
      inProgress: false,
      message: countLabel + '. Recorrido completo de todas las páginas de Kommo, sin límite de 2.000.'
    };
  }

  // Compatibilidad con un backend GAS aún sin desplegar: no confundir
  // la respuesta legacy de una sola llamada con un recorrido nuevo completo.
  if (result.truncado === true || (result.truncadoDetalle && String(result.truncadoDetalle).includes('leads'))) {
    const cap = Number(result.maxLeads);
    const capLabel = Number.isFinite(cap) && cap > 0 ? ' (límite ' + cap.toLocaleString('es-CL') + ')' : '';
    return {
      warning: true,
      inProgress: false,
      message: countLabel + '. Sincronización parcial' + capLabel + ': podrían faltar leads antiguos.'
    };
  }
  return {
    warning: true,
    inProgress: false,
    message: countLabel + '. La API antigua no certifica la cobertura total; hace falta publicar el nuevo sincronizador.'
  };
}
